import { Component, ChangeDetectionStrategy, ChangeDetectorRef } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { BookDemoModalComponent } from '../book-demo-modal/book-demo-modal.component';

@Component({
  selector: 'app-recruiter-cta',
  standalone: true,
  imports: [CommonModule, RouterModule, BookDemoModalComponent],
  templateUrl: './recruiter-cta.component.html',
  styleUrls: ['./recruiter-cta.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class RecruiterCtaComponent {
  isDemoModalOpen = false;
  initialModalOption: 'demo' | 'quote' = 'demo';

  constructor(private cdr: ChangeDetectorRef) {}

  openModal(option: 'demo' | 'quote') {
    this.initialModalOption = option;
    this.isDemoModalOpen = true;
    this.cdr.markForCheck();
  }

  closeModal() {
    this.isDemoModalOpen = false;
    this.cdr.markForCheck();
  }
}
